import { morphism } from 'morphism';
import { createStrictSchema, createUnknownSchema } from '../../utils/morph.js';

const voBannerSchema = createStrictSchema({
    bannerId: 'banner_id',
    title: 'title',
    description: 'description',
    code: 'code',
    placeholders: 'placeholders',
    icon: 'icon',
    color: 'color',
    design: 'style',
    tag: 'tag',
    countdown: 'countdown',
    cta: 'cta',
});
const voBannersSchema = createStrictSchema({
    banners: {
        path: 'banners',
        fn: morphism(voBannerSchema),
    },
});
const privateBannerSchema = createStrictSchema({
    bannerId: 'banner_id',
    title: 'title',
    description: 'description',
    activeFrom: 'active_from',
    activeTo: 'active_to',
    code: 'code',
    icon: 'icon',
    color: 'color',
    categories: 'categories',
    channels: 'channels',
    entrypoints: 'entry_points',
    enabled: 'enabled',
    isPro: 'is_pro',
    pages: 'pages',
    placeholders: 'placeholders',
    template: 'template',
    design: 'style',
    tag: 'tag',
    countdown: 'countdown',
    cta: 'cta',
});
const bannerListSchema = createStrictSchema({
    count: 'count',
    banners: {
        path: 'banners',
        fn: morphism(privateBannerSchema),
    },
});
const rulesToRawSchema = createUnknownSchema({
    categories: 'categories',
    channels: 'channels',
    entry_points: 'entrypoints',
    is_pro: 'isPro',
    pages: 'pages',
    placeholders: 'placeholders',
});
const toPrivateBannerRawSchema = createUnknownSchema({
    title: 'title',
    description: 'description',
    active_from: 'activeFrom',
    active_to: 'activeTo',
    code: 'code',
    icon: 'icon',
    color: 'color',
    enabled: 'enabled',
    template: 'template',
    style: 'design',
    tag: 'tag',
    countdown: 'countdown',
    cta: 'cta',
    rules: morphism(rulesToRawSchema),
});

export { bannerListSchema, privateBannerSchema, toPrivateBannerRawSchema, voBannerSchema, voBannersSchema };
//# sourceMappingURL=morph.js.map
